import { useDispatch } from "react-redux";
import { actions, getUserLang } from "../redux/localizations";
import { useEffect, Suspense } from "react";
import i18n from "i18next";
import { initReactI18next, I18nextProvider } from "react-i18next";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Loading } from "../components/Loading";

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  saveMissing: true,
  interpolation: {
    escapeValue: false,
  },
});

export const Translation = ({ children }) => {
  const dispatch = useDispatch();
  const locale = getUserLang();
  useEffect(() => {
    // init lang
    dispatch(actions.fetchLang(getUserLang()));
  }, [dispatch]);

  return (
    <I18nextProvider i18n={i18n} defaultNS="translations">
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
        <Suspense fallback={<Loading />}>{children}</Suspense>
      </LocalizationProvider>
    </I18nextProvider>
  );
};
